export const TELEOP_ANT_ALERT_CONTAINER_ID = "teleop-ant-alert-container";
